import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TentangKami = () => {
  return (
    <>
      <Navbar />
      <div style={{ marginLeft: '50px', marginRight: '50px' }}>
        <header className="header-banner">
          <h2>Visi dan Misi Komite SKK Sektor Transportasi dan Logistik</h2>
        </header>

        <section className="visi-misi-content">
          <h3>Dasar Hukum</h3>
          <ul>
            <li>Peraturan Pemerintah Nomor 51 Tahun 2012 Tentang Sumber Daya Manusia Bidang Transportasi</li>
            <li>Peraturan Menteri Perhubungan Nomor 7 Tahun 2018 Tentang Rencana Induk Pengembangan Standar Kompetensi Kerja Nasional Indonesia Sektor Transportasi </li>
            <li>Keputusan Menteri Perhubungan Nomor 121 Tahun 2023 Tentang Komite Standar Kompetensi Kerja Sektor Transportasi</li>
            <li>Keputusan Ketua Komite Standar Kompetensi Kerja Sektor Transportasi Nomor 15 Tahun 2025 Tentang Pembentukan Kelompok Kerja (POKJA) Standar Kompetensi Kerja Sektor Transportasi</li>
          </ul>

          <h3>Tugas</h3>
          <ul>
            <li>Merumuskan dan mengembangkan Standar Kompetensi Kerja Nasional Indonesia (SKKNI), Standar Kompetensi Kerja Khusus (SKKK), dan Standar Kompetensi Kerja Internasional (SKKI) di bidang transportasi dan logistik.</li>
            <li>Melakukan kajian dan pemutakhiran standar kompetensi kerja berdasarkan perkembangan teknologi dan regulasi.</li>
            <li>Menyusun rekomendasi kebijakan terkait pengembangan tenaga kerja sektor transportasi dan logistik</li>
            <li>Mengawasi dan mengevaluasi implementasi standar kompetensi kerja di lembaga pendidikan dan pelatihan.</li>
            <li>Mengembangkan sistem sertifikasi berbasis digital untuk tenaga kerja transportasi dan logistik</li>
            <li>Mendorong peningkatan kapasitas SDM melalui program pelatihan berbasis kompetensi</li>
          </ul>

          <h3>Fungsi</h3>
          <ul>
            <li>Penyusunan Standar – Menyusun standar kompetensi kerja yang relevan dengan kebutuhan industry transportasi dan logistik. Evaluasi dan Pengawasan – Memastikan implementasi standar kompetensi berjalan efektif dan sesuai dengan kebutuhan industri.</li>
            <li>Sertifikasi Kompetensi – Memfasilitasi dan mengawasi proses sertifikasi tenaga kerja untuk menjamin kualitas SDM di sektor transportasi dan logistik.</li>
            <li>Sinergi dan Kolaborasi – Membangun kerja sama dengan berbagai pemangku kepentingan untuk pengembangan standar kompetensi kerja yang efektif.</li>
            <li>Mengawasi dan mengevaluasi implementasi standar kompetensi kerja di lembaga pendidikan dan pelatihan.</li>
            <li>Pemantauan Tren Industri – Melakukan riset dan kajian untuk memastikan standar kompetensi selalu mengikuti perkembangan teknologi dan kebutuhan industri.</li>
          </ul>

          <h3>Visi</h3>
          <p>Mewujudkan tenaga kerja transportasi dan logistik yang kompeten, profesional, dan berdaya saing global melalui standar kompetensi kerja yang adaptif dan berbasis teknologi modern</p>

          <h3>Misi</h3>
          <ul>
            <li>Mengembangkan standar kompetensi kerja yang sesuai dengan perkembangan industri transportasi dan logistik berbasis digital serta kebutuhan pasar kerja nasional dan internasional</li>
            <li>Meningkatkan kapasitas dan kapabilitas tenaga kerja melalui pelatihan berbasis kompetensi yang berorientasi pada teknologi, keselamatan, dan keamanan.</li>
            <li>Menyelaraskan standar kompetensi dengan regulasi nasional dan internasional untuk meningkatkan daya saing tenaga kerja</li>
            <li>Memfasilitasi sertifikasi kompetensi tenaga kerja untuk memastikan standar keahlian dan profesionalisme di sektor transportasi dan logistik.</li>
            <li>Berinovasi dalam penerapan teknologi digital untuk pengelolaan data dan pemantauan kompetensi tenaga kerja secara real-time</li>
            <li>Membangun kemitraan strategis dengan dunia industri, akademisi</li>
          </ul>

          <h3>Tentang</h3>
          <p> Komite Standar Kompetensi Kerja (SKK) Sektor Transportasi dan Logistik merupakan lembaga yang bertugas dalam penyusunan, pengembangan, dan pemutakhiran Standar Kompetensi Kerja Khusus (SKKK), Standar Kompetensi Kerja Nasional Indonesia (SKKNI), serta Standar Kompetensi Kerja Internasional (SKKI) di sector transportasi dan logistik. Komite ini berperan penting dalam memastikan bahwa standar kompetensi yang diterapkan selaras dengan kebutuhan industri, perkembangan teknologi, serta regulasi yang berlaku. Dengan melibatkan berbagai pemangku kepentingan, seperti pemerintah (regulator), asosiasi industri, akademisi, dan perusahaan terkait lainnya. Komite ini bertujuan selain untuk meningkatkan kualitas sumber daya manusia (SDM) transportasi dan logistik juga dapat  mendukung daya saing tenaga kerja, serta memperkuat  keselamatan dan keamanan dalam sektor transportasi dan logistik.</p>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default TentangKami;
